import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class ModelService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * Get vehicle models
   * @returns Array
   */
  getAllModels(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/models`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get all models associated with a particular make
   * @param makeID
   * @returns Array
   */
  getModelsByMake(makeID:string): Observable<ApiResponse>{
    
    let apiURL:string=`${this.baseURL}/v1/models-by-make/${makeID}`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

   /**
   * Create new model
   * @param formData 
   * @returns array
   */
  saveModel(formData:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/models`;

    return this.httpClient.post(apiURL,formData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get vehicle model for editing
   * @returns Array
   */
  edit(id:string){

    let apiURL:string=`${this.baseURL}/v1/models/${id}/edit`;

    return this.httpClient.get(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update model
   * @param modelData 
   * @param Id 
   * @returns array
   */
  update(modelData:any,Id: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/models/${Id}`;

    return this.httpClient.put(apiURL,modelData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
